module.exports = __webpack_public_path__ + "img/1_04.d17408df.jpg";